import './_provider-input.scss';
import './_provider-input.dark-mode.scss';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import FormSwitch from '../../FormSwitch';
import Spinner from '../../Loaders/Spinner';
import Tooltip from '../../Tooltip';

const ProviderInput = ({
  name,
  serviceRateConverted,
  providerCurrency,
  isLoading,
  syncMode,
  syncValue,
  rateFixed,
  ratePercent,
  value,
  onChange,
  providerValue,
  onChangeSync,
  onChangeRateFixed,
  onChangeRatePercent,
  required,
  syncDisabled,
}) => {
  const onChangeSwitch = () => {
    onChangeSync(!syncValue);
  };
  const onBlurRate = (e) => {
    const newTarget = e;
    if (e.target.value) {
      newTarget.target.value = parseFloat(e.target.value)
      if (value !== newTarget.target.value) {
        onChange(newTarget)
      }
    }
  };
  const onBlurFixedRate = (e) => {
    const newTarget = e;
    if (e.target.value) {
      newTarget.target.value = parseFloat(e.target.value);
      if (rateFixed !== newTarget.target.value) {
        onChangeRateFixed(newTarget)
      }
    }
  };
  const { config } = useSelector((state) => state.services);
  const currency = config?.currency;
  return (
    <div
      className={classNames('provider-input__wrapper', {
        'provider-input': providerValue,
        'provider-input__with-sync': syncMode,
      })}
    >
      {syncMode && syncMode === 'rate' && syncValue ? (
        <div className="provider-input__sync-rate">
          <div className="provider-input__sync-rate-input provider-input__sync-rate-input-fixed">
            <div className="provider-input__sync-rate-label">Fixed, 1.00</div>
            <input
              type="text"
              id="rate_fixed"
              name="auto_rate_fixed"
              className="form-control"
              placeholder="0"
              value={rateFixed || ''}
              onChange={onChangeRateFixed}
              onBlur={onBlurFixedRate}
            />
          </div>
          <div className="provider-input__sync-rate-input provider-input__sync-rate-input-percent">
            <div className="provider-input__sync-rate-label">Percent, %</div>
            <input
              type="text"
              id="rate_percent"
              name="auto_rate_percent"
              className="form-control"
              placeholder="0"
              value={ratePercent || ''}
              onChange={onChangeRatePercent}
            />
          </div>
          <div className="provider-input__sync-rate-values">
            <div className="provider-input__sync-rate-custom">{isLoading ? <Spinner /> : value}</div>
            <div className="provider-input__sync-rate-provider">
              {serviceRateConverted ? (
                <Tooltip placement="top" tooltipClass="tooltip__top" text={`${providerValue} ${providerCurrency || ''}`}>
                  <span>
                    ≈
                    {' '}
                    {serviceRateConverted}
                    {' '}
                    {currency || ''}
                  </span>
                </Tooltip>
              ) : (
                <>
                  {providerValue}
                  {' '}
                  {providerCurrency || ''}
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <input
          type="text"
          id={name}
          name={name}
          disabled={syncValue}
          onBlur={onBlurRate}
          className="form-control"
          value={syncValue ? providerValue || '' : value}
          onChange={onChange}
          required={required}
        />
      )}
      {syncMode ? (
        <div className={classNames('provider-input__sync', {
          'provider-input__sync-disabled': syncDisabled,
        })}
        >
          <FormSwitch
            disabled={syncDisabled}
            size="small"
            id={`sync_${name}`}
            name={`auto_${name}`}
            checked={!!syncValue}
            onChange={onChangeSwitch}
            tooltipText={syncDisabled
              ? (
                <p>
                  Current provider does not
                  <br />
                  {' '}
                  support the
                  {' '}
                  {name}
                  {' '}
                  sync feature
                </p>
              )
              : (
                <p>
                  Sync
                  {' '}
                  {name}
                  {' '}
                  with provider
                </p>
              )}
          />
        </div>
      ) : null}
      {providerValue && !(syncValue && syncMode === 'rate') ? (
        <label htmlFor={name} className="provider-input__value">
          {serviceRateConverted ? (
            <Tooltip placement="left" tooltipClass="tooltip__left" text={`${providerValue} ${providerCurrency || ''}`}>
              <span>
                ≈
                {' '}
                {serviceRateConverted}
                {' '}
                {currency || ''}
              </span>
            </Tooltip>
          ) : (
            <>
              {providerValue}
              {' '}
              {providerCurrency || ''}
            </>
          )}
        </label>
      ) : null}
    </div>
  );
};
ProviderInput.defaultProps = {
  required: true,
}

ProviderInput.propTypes = {
  name: PropTypes.string,
  serviceRateConverted: PropTypes.string,
  providerCurrency: PropTypes.string,
  isLoading: PropTypes.any,
  syncMode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  rateFixed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ratePercent: PropTypes.string,
  syncValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  providerValue: PropTypes.any,
  onChangeSync: PropTypes.func,
  onChangeRateFixed: PropTypes.func,
  onChangeRatePercent: PropTypes.func,
  required: PropTypes.bool,
  syncDisabled: PropTypes.bool,
};

export default ProviderInput;
